import { SdcFluxModule } from '../../sdc/flux/sdc-flux.module';
import nvSharedServicesUtilsModule from '../../shared/services/utilities/nv.shared.services.utils.module';
import { SchoolToolbarService } from './school-toolbar/school-toolbar.service';

export const ToolbarsModule = angular
  .module('nv.toolbars', [nvSharedServicesUtilsModule, 'nv.shared.modals', SdcFluxModule])
  .service('SchoolToolbarService', SchoolToolbarService).name;
